export class AppConstants {
    // App Constants
    public static USERID = 'USER_ID';
    public static IS_PAYMENT_REQUIRED = 'IS_PAYMENT_REQUIRED';
    public static ENROLLMENT_STAGE = 'ENROLLMENT_STAGE';
    public static USER_LOGGED_IN = 'USER_LOGGED_IN';
    public static NewEnrollmentModel = 'NewEnrollmentModel';
    public static TOKEN = 'token';
    public static CLIENT_CORRELATION_ID = 'CLIENT_CORRELATION_ID';
    public static PARTICIPATION_ID = 'PARTICIPATION_ID';
    public static TERMS = 'TERMS';
    public static ENROLLMENT_TYPE = 'ENROLLMENT_TYPE';
    public static GLOBAL_HEADER = 'GLOBAL_HEADER';
    public static GLOBAL_FOOTER = 'GLOBAL_FOOTER';
    public static UNIVERSITY_NAME = 'UNIVERSITY_NAME';
    public static PARTICIPATION_LABEL = 'PARTICIPATION_LABEL';
    public static DOB: any;
    public static WaiverModel = 'WaiverModel';
    public static UserDetails = 'UserDetails';
    public static StatesData = 'States';
    public static STORY_ID = 'STORY_ID';
    public static MICROSITE_STORY_ID = 'MICROSITE_STORY_ID';
    public static LOGIN_EMAIL = 'LOGIN_EMAIL';
    public static MICROSITE_ID = 'MICROSITE_ID';
    public static MICORSITE_TITLE = 'MICORSITE_TITLE';
    public static MICROSITE_SUBTITLE = 'MICROSITE_SUBTITLE';
    public static STUDENT_ID_PATTEREN= 'STUDENT_ID_PATTEREN';

    // Status
    public static INVALID_STATUS = 'INVALID';
    public static FAILURE_STATUS = 'FAILURE';
    public static FAILED_STATUS = 'FAILED';
    public static LOCKED_STATUS = 'LOCKED';
    public static SUCCESS_STATUS = 'SUCCESS';
    public static ERROR_STATUS = 'ERROR';
    public static INPUT_STATUS = 'REG_ERR_101';
    public static ROSTER_NOT_FOUND_STATUS = 'REG_ERR_102';
    public static REGISTRATION_ERROR_STATUS = 'REG_ERR_103';
    public static USER_EXISTS_STATUS = 'REG_ERR_104';
    public static SYSTEM_STATUS = 'REG_ERR_105';
    public static ENROLL_STATUS = 'REG_ERR_106';
    public static USERNAME_PASS_PARTIAL_MATCH_STATUS = 'REG_ERR_107';
    public static ENROLLMENT_ID = 'ENROLLMENT_ID';
    public static WRONG_FILE_FORMAT = 'UPLOAD_ERR_101';
    public static SIZE_ERROR = 'UPLOAD_ERR_102';
    public static CORRUPT_FILE_ERROR = 'UPLOAD_ERR_104';
    public static OVERDUE_ERROR = 'WAIVER_ERR_102';
    public static WRONG_LEFT_FILE_LABEL = 'UPLOAD_ERR_105';
    public static WRONG_RIGHT_FILE_LABEL = 'UPLOAD_ERR_106';

    // Data Service
    public static LOGIN_FAILED = 'LOGIN_FAILED';
    public static REGISTRATION_FAILED = 'REGISTRATION_FAILED';
    public static REGISTRATION_SUCCESS = 'REGISTRATION_SUCCESS';
    public static FORGOT_PD_FAILED = 'SENDING_RESET_MAIL_FAILED';
    public static FORGOT_PD_SUCCESS = 'SENDING_RESET_MAIL_SUCCESS';
    public static RESET_PD_FAILED = 'RESET_PD_FAILED';
    public static RESET_PD_SUCCESS = 'RESET_PD_SUCCESS';
    public static HIDE_MENU = 'HIDE_MENU';
    public static DASHBOARD_FAILED = 'DASHBOARD_FAILED';
    public static SUCCESS = 'SUCCESS';
    public static WAIVER_FAILED = 'WAIVER_FAILED';
    public static WAIVER_SUCCESS = 'WAIVER_SUCCESS';

    // For Dashboard (After login)
    public static DASHBOARD_WAIVED_SUCCESS = 'DASHBOARD_WAIVED_SUCCESS';
    public static DASHBOARD_DEPENDENT_SUCCESS = 'DASHBOARD_DEPENDENT_SUCCESS';
    public static DASHBOARD_ENROLLED_SUCCESS = 'DASHBOARD_ENROLLED_SUCCESS';

    // My Account - My Details
    public static MY_ACCOUNT = 'MY_ACCOUNT';
    public static UPDATE_MYDETAILS_SUCCESS = 'UPDATE_MYDETAILS_SUCCESS';

    // My Account - Login Info
    public static CHANGE_PD_SUCCESS = 'CHANGE_PD_SUCCESS';

}
